import { render, staticRenderFns } from "./TjjNewsList.vue?vue&type=template&id=7c5678f8&scoped=true"
import script from "./TjjNewsList.vue?vue&type=script&lang=js"
export * from "./TjjNewsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5678f8",
  null
  
)

export default component.exports